import { FC } from 'react';

import { Modal } from '@smartshell/ui-kit';

import { ClientCard } from '../../components';
import { IWorkerModal } from './interfaces';
import s from './Worker.module.scss';

export const WorkerModal: FC<IWorkerModal> = ({ onClose, clientUUID }) => {
  return (
    <Modal onClose={onClose} className={s.modal}>
      <ClientCard
        notShowButtonDeposit={true}
        hidePausableTariff={true}
        clientUUID={clientUUID}
        showResetPassword={false}
      />
    </Modal>
  );
};
